// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_92d58ee7","amount":"rdg_771a3454","discount":"rdg_34b7fcd8 rdg_771a3454","old":"rdg_e9488a2e rdg_771a3454"};